import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @format */

import React from 'react';
import { memberProfileDefaultProps, memberProfilePropType } from "../../../constants/app";
import { Button, Section, ProfileLoginWrapper, MessageWrapper } from "./style";
import withMemberProfile from "../withMemberProfile";
var MemberProfileMobile = function MemberProfileMobile(props) {
  var _memberProfileDefault = _objectSpread(_objectSpread({}, memberProfileDefaultProps), props),
    openLoginModal = _memberProfileDefault.openLoginModal,
    toggleSideMenu = _memberProfileDefault.toggleSideMenu,
    authenticated = _memberProfileDefault.authenticated,
    authorized = _memberProfileDefault.authorized,
    firstName = _memberProfileDefault.firstName,
    removeAndSyncShoSession = _memberProfileDefault.removeAndSyncShoSession;
  var handleLoginClick = function handleLoginClick() {
    toggleSideMenu();
    openLoginModal(window.location.href);
    removeAndSyncShoSession();
  };
  var handleLogoutClick = function handleLogoutClick() {
    window.location.href = '/logout';
  };
  return __jsx(Section, null, !authenticated && !authorized && __jsx(Button, {
    onClick: handleLoginClick
  }, "LOG IN"), authorized && __jsx(ProfileLoginWrapper, null, firstName && __jsx("div", {
    className: "name"
  }, "Hi ", firstName), authorized && !authenticated && __jsx(MessageWrapper, null, "Not you?\xA0", __jsx("a", {
    onClick: handleLoginClick,
    role: "link"
  }, "Log in to your account")), authorized && authenticated && __jsx(MessageWrapper, {
    justifyContent: "space-between"
  }, "Welcome back", __jsx("a", {
    onClick: handleLogoutClick,
    role: "link"
  }, "Log out"))));
};
export default withMemberProfile(MemberProfileMobile);